import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { Box, Typography, Container, Paper, Chip, Button, CircularProgress } from "@mui/material";
import axiosInstance from "../api/axiosInstance";

const ContentInfo = () => {
    const { subjectParam, contentId } = useParams();
    const [content, setContent] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchDetail = async () => {
            try {
                // Assuming we fetch by subject and content_id
                const res = await axiosInstance.get(`/post/contents/${subjectParam}/${contentId}`);
                setContent(res.data);
            } catch (err) {
                console.error("Error fetching content info:", err);
            } finally {
                setLoading(false);
            }
        };
        fetchDetail();
    }, [subjectParam, contentId]);

    if (loading) {
        return (
            <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", minHeight: "60vh" }}>
                <CircularProgress />
            </Box>
        );
    }

    if (!content) {
        return (
            <Container maxWidth="md" sx={{ py: 10, textAlign: "center" }}>
                <Typography variant="h5" color="error">Content Not Found</Typography>
                <Button component={Link} to="/" sx={{ mt: 2 }}>Go Home</Button>
            </Container>
        );
    }

    return (
        <Container maxWidth="md" sx={{ py: 8 }}>
            <Paper
                elevation={0}
                sx={{
                    p: { xs: 3, md: 6 },
                    borderRadius: 6,
                    border: "1px solid",
                    borderColor: "divider",
                    background: (theme) => theme.palette.mode === "dark"
                        ? "linear-gradient(135deg, rgba(255,255,255,0.05) 0%, rgba(255,255,255,0) 100%)"
                        : "#fff"
                }}
            >
                <Typography variant="h3" fontWeight={900} gutterBottom sx={{
                    background: "linear-gradient(135deg, #e50914, #6a0dad)",
                    WebkitBackgroundClip: "text",
                    WebkitTextFillColor: "transparent"
                }}>
                    Content Registry
                </Typography>

                <Box sx={{ mt: 5, display: "flex", flexDirection: "column", gap: 4 }}>
                    <Box>
                        <Typography variant="overline" sx={{ letterSpacing: 2, fontWeight: 700, color: "text.secondary" }}>
                            MODULE TITLE
                        </Typography>
                        <Typography variant="h4" fontWeight={700}>{content.title}</Typography>
                    </Box>

                    <Box sx={{ display: "flex", flexWrap: "wrap", gap: 3 }}>
                        <Box>
                            <Typography variant="overline" sx={{ letterSpacing: 2, fontWeight: 700, color: "text.secondary" }}>
                                UNIQUE IDENTIFIER (ID)
                            </Typography>
                            <Box sx={{ mt: 1 }}>
                                <Chip
                                    label={content.content_id}
                                    sx={{
                                        height: 40, px: 2, fontSize: "1.2rem", fontWeight: 900,
                                        borderRadius: 2, bgcolor: "primary.main", color: "#fff"
                                    }}
                                />
                            </Box>
                        </Box>

                        <Box>
                            <Typography variant="overline" sx={{ letterSpacing: 2, fontWeight: 700, color: "text.secondary" }}>
                                COURSE SLUG
                            </Typography>
                            <Typography variant="h5" color="secondary" fontWeight={600} sx={{ mt: 1 }}>
                                {content.subject.toUpperCase()}
                            </Typography>
                        </Box>
                    </Box>

                    <Box sx={{ pt: 4, borderTop: "1px solid", borderColor: "divider", display: "flex", gap: 2 }}>
                        <Button
                            variant="contained"
                            size="large"
                            component={Link}
                            to={`/${subjectParam}/${contentId}`}
                            sx={{
                                borderRadius: 3, px: 4, py: 1.5, fontWeight: 700,
                                background: "linear-gradient(135deg, #e50914, #6a0dad)"
                            }}
                        >
                            Open Lesson
                        </Button>
                        <Button
                            variant="outlined"
                            size="large"
                            component={Link}
                            to="/"
                            sx={{ borderRadius: 3, px: 4, fontWeight: 700 }}
                        >
                            Back to courses
                        </Button>
                    </Box>
                </Box>
            </Paper>
        </Container>
    );
};

export default ContentInfo;
